import MCapService from "@/services/MCapService.js";

export const namespaced = true;

export const state = {
  months: [],
  client_direct_orders: [],
  client_direct_orders_edit: [],
  recipients: []
};

export const mutations = {
  SET_MONTHS(state, months) {
    //console.log(months);
    //alert("start mutation")
    state.months = months;
    //alert("end mutation")
    //alert(getters.MonthCount)
    return true;
  },
  SET_CLIENT_DIRECT_ORDERS(state, orders) {
    state.client_direct_orders = orders;
  },
  SET_CLIENT_DIRECT_ORDER_EDIT(state, order) {
    state.client_direct_order_edit = order;
  },
  SET_RECIPIENTS(state, recipients) {
    state.recipients = recipients;
  }
};

export const getters = {
  getOrderById: state => id => {
    //console.log(state)
    return state.client_direct_orders.find(order => order.OrderID === id);
  },
  // getMonthByBase: state => {
  //   return state.months.find(month => month.CapBase === "201909")
  // },
  OrderCount: state => {
    return state.client_direct_orders.length;
  },
  MonthCount: state => {
    return state.months.length;
  },
  RecipientCount: state => {
    return state.recipients.length;
  }
};

export const actions = {
  getMonths({ commit }) {
    return new Promise((resolve, reject) => {
      MCapService.get_months()
        .then(response => {
          commit("SET_MONTHS", response.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error.message);
          reject(error);
        });
    });
  },
  getClientDirectOrders({ commit }, value) {
    return MCapService.get_ClientDirectOrders(value)
      .then(response => {
        commit(
          "SET_CLIENT_DIRECT_ORDERS",
          response.data["ClientDirectOrdersResult"]
        );
      })
      .catch(error => {
        console.log(error.message);
      });
  },
  loadOrderEdit({ commit, getters, dispatch }, value) {
    var order = getters.getOrderById(value);
    if (order) {
      commit("SET_CLIENT_DIRECT_ORDER_EDIT", order);
    } //else {
    //console.log("calling API")
    //}
  },
  loadRecipients({ commit, getters, dispatch }, value) {
    return MCapService.get_ClientDirectRecipients(value)
      .then(response => {
        commit("SET_RECIPIENTS", response.data["ClientDirectRecipientsResult"]);
      })
      .catch(error => {
        console.log(error.message);
      });
  }
};
